/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePsychoDto } from '../../models/response-psycho-dto';
import { UpdatePsychoDto } from '../../models/update-psycho-dto';

export interface PsychosControllerUpdate$Params {

/**
 * The tenant of the psycho
 */
  tenant: string;

/**
 * The psycho id
 */
  id: string;
      body: UpdatePsychoDto
}

export function psychosControllerUpdate(http: HttpClient, rootUrl: string, params: PsychosControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
  const rb = new RequestBuilder(rootUrl, psychosControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePsychoDto>;
    })
  );
}

psychosControllerUpdate.PATH = '/thalea-psychos/psychos/{tenant}/{id}';
